<template style="height: 100%">
    <div class="ra mrt10 leftborder">
        <!--头部-->
        <div class="ml5">
            <span style="font-size: 16px;font-weight: bold">|</span>
            <span class="mrl20"  style="font-size: 16px; font-weight: bold">放映素材</span>
        </div>
        <div class="flex mrt10 ml5">
            <template>
                <!--                <span class=" middle" style="font-size: 14px">选择日期:</span>-->
                <el-date-picker
                        size="mini"
                        v-model="begin_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        style="width: 15%"
                        placeholder="选择日期">
                </el-date-picker>
                <span class=" middle" style="font-size: 14px">-</span>
                <el-date-picker
                        size="mini"
                        v-model="end_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        style="width: 15%"
                        placeholder="选择日期">
                </el-date-picker>
            </template>
            <template>
                <el-select v-model="value" placeholder="所有类型" disabled size="mini" style="width: 15%" class="mrl20" @change="optiondata">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-input class="mrl20" style="width: 15%" v-model="explain" placeholder="请输入" clearable size="mini"></el-input>
                <el-button icon="el-icon-search" class="mrl20"  @click="searchData"  size="mini" circle></el-button>
                <el-button class="mrl20" type="primary" @click="addData"  :disabled="disabled" :class="baseerp+'btn'" size="mini" >+上传素材</el-button>
              </template>
        </div>
        <!--素材部分-->
        <div  class="tableHeight ml5">
            <div class="flex" >
                <div v-for="(item,index) in allimgData" :key="index" :idx="index" class="mrt15 mrl15 view mrb10" :id="item.i_id" style="margin: 10px;padding: 10px;;background-color: #f6f6f6" >
                    <div class="flex" style="width:180px; margin: 5px 0px;">
                        <div style="width: 8px;height: 8px;border-radius: 50%;background-color: orange;margin: 10px 0px;"></div>
                        <span style="margin: 3px;text-align: center;">{{item.i_type=="2"?"图片":"视频"}}</span>
                        <span style="color: #999;font-size: 14px;margin: 5px 0px 5px 20px;">{{"上传于"+item.dt_createtime}}</span>
                    </div>
                    <div>
                        <img :src="item.vc_path" style="height:130px; width:180px" v-if="item.i_type=='2'">
                        <video :src="item.vc_path" style="height:130px; width:180px" v-else controls="controls" ></video>
                    </div>
                    <div>
                        <span style="display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:180px;">{{item.vc_introducion}}</span>
                    </div>
                    <div>
                        <el-button @click="delmaterial(item)" icon="el-icon-delete" style="border: none;margin: 0px 0px 0px 130px;background: none;"></el-button>
                    </div>
                </div>
            </div>
            <div class="mrt20">
            <div class="pagetxt">
                <span>共{{tableTotal}}条，每页显示{{pageSize}}条</span>
            </div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
            </div>
        </div>
        <!--dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="800px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <upload-material :application="application" @close="cancelDialog" @getResourceList="getResourceList"></upload-material>
            </el-dialog>
        </div>

        <!--分页-->
        <!--<div>

        </div>-->
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from  "../api";
    import axios from "axios";
    import uploadMaterial from "./uploadMaterial";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "materialList",
        components:{uploadMaterial},
        props:{
            material:{
                type:Object,
                required:true,

            }
        },
        mounted(){
            this.baseerp=baseerp;
            ///调用列表接口
            //this.getlist();
            // console.log(this.formvalue,"this.formvalue");
            /*this.$nextTick(function () {
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.tableHeight = window.innerHeight - self.$refs.table.$el.clientTop - 280
                }
                // console.log(window.innerHeight,"H")
            })
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度　*/

        },

        data(){
            return{
                idList:[],
                iType:"",
                allimgData:[
                    /*{
                        i_id:'001',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg",
                        i_type:1,
                        creat_time:"2022-06-01",
                        content:"一些说明一些说明一些说明一些说明",
                    },
                    {
                        i_id:'002',
                        vc_path:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/A87FF679A2F3E71D9181A67B7542122C4/1653906906036.png",
                        i_type:2,
                        creat_time:"2022-06-01",
                        content:"一些说明一些说明一些说明一些说明",
                    },
                    {
                        i_id:'003',
                        vc_path:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/E4DA3B7FBBCE2345D7772B0674A318D55/1654070497612.png",
                        i_type:1,
                        creat_time:"2022-06-01",
                        content:"一些说明一些说明一些说明一些说明",
                    },
                    {
                        i_id:'004',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg",
                        i_type:2,
                        creat_time:"2022-06-01",
                        content:"一些说明一些说明一些说明一些说明",
                    },
                    {
                        i_id:'005',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg",
                        i_type:1,
                        creat_time:"2022-06-01",
                        content:"一些说明一些说明一些说明一些说明",
                    },{
                        i_id:'006',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg",
                        i_type:2,
                        creat_time:"2022-06-01",
                        content:"一些说明一些说明一些说明一些说明",
                    }*/
                ],
                //typedata:"",
                options: [{
                    value: 0,
                    label: "全部"
                },{
                    value: 1,
                    label: '视频'
                }, {
                    value: 2,
                    label: '图片'
                }],
                value: '',
                groupid:"",
                showscheduleId:"",
                explain:"",
                /***********************************/
                i_id:"",
                i_type:"",
                apptitle:"",
                bfapp:[],
                dialogVisible:false,
                title:"",
                begin_time:"",
                end_time:"",
                tableData:[],
                pageSize:12,
                currentPage:1,
                tableTotal:0,
                vcName:"",
                application:{},
                highlightCurrentRow:false,
                disabled:false,
                baseerp:"",
                mid:0,
                tableHeight:0,
            }
        },
        watch:{
            material:{
                handler(){
                    if (this.material){
                        //console.log("父index给到子列表",this.material);
                        this.iType=this.material.i_id;
                        this.value=this.iType;
                        //this.groupid=this.showschedule.value.i_groupId;
                        //console.log(this.iType,"iType");
                        this.getResourceList();
                        /*if ((this.material.i_id ?? '' !== '') && (this.showschedule.i_id != 0)){

                        }*/
                    }
                },
                immediate:true,
                deep:true
            },

        },

        methods:{
            ...mapActions(["getCurrentMenuId"]),

            optiondata(val){
                //console.log(val,"val");
                this.value=val;
                //console.log(this.value,"value");
            },

            //当前行color==3 整行灰掉
            tableRowClassName({row,rowIndex}){
                //console.log(row.id,"id");
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.color == 1) {

                    return 'danger-row';
                }
            },

            //拿到当前行数据
            rowClick(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
                this.application.i_pid=row.i_pid;
                // console.log(this.application,"this.application",this.application.i_pid)
            },

            //关闭dialog
            cancelDialog(val){
                //console.log(val,"val,,,,,,");
                this.application.i_pid="";
                this.dialogVisible=false;
                //  console.log(this.application.i_pid,"cancelDialog");
                this.highlightCurrentRow=false;
                //this.getArrangementList(val);
                this.getResourceList(val);
            },

            //点击编辑
            editData(row){
                this.title="编辑放映";
                this.dialogVisible=true;
                this.application={
                    i_id:row.id,
                    value:row,
                    schedule:this.showschedule,
                };
                //console.log(this.application,"editData");
                /*if (this.application.i_pid==""||this.application.i_pid==undefined){
                    //  console.log(this.application,"this.application",this.application.i_pid);
                    this.dialogVisible=false;
                    this.$message.error("请选择要编辑的行内容！")
                }else{
                    this.application={
                        i_pid:this.application.i_pid,
                        page_size:this.currentPage,
                        value:this.bfapp,
                        i_id:this.i_id,
                        i_type:this.i_type,
                        title:this.title,
                        i_mid:this.mid,
                    };
                    //  console.log(this.application,"editData");
                    this.dialogVisible=true;
                }*/

            },

            //点击删除
            delData(row){
                //console.log("row",row);
                this.showId=row.i_id;
                this.delArrangement();
            },

            //点击添加
            addData(){
                this.title="上传素材";
                this.dialogVisible=true;
                this.application={
                    i_type:this.value,
                };
                /*if(this.formvalue.title==null||this.formvalue==null){
                    this.dialogVisible=false;
                    this.$message.error("请选择要的添加左侧单！")
                }else{
                    this.title="添加申请单";
                    this.highlightCurrentRow=false;
                    this.application={
                        i_pid:0,
                        page_size:1,
                        value:this.bfapp,
                        i_id:this.i_id,
                        i_type:this.i_type,
                        title:this.title,
                        i_mid:this.mid,
                    };
                    // console.log(this.application,"addData");
                    this.dialogVisible=true;
                }*/

            },


            delmaterial(val){
                //console.log("delval",val,"page",this.currentPage);
                let id=val.i_mr_id;
                this.idList.push(id);
                //console.log("idList","this.idList");
                this.batchDelResource();
            },


            //点击查询
            searchData(){
                //console.log(this.explain,this.begin_time,this.end_time,"searchData");
                ///调用列表接口
                //this.getArrangementList();
                  this.getResourceList();
            },

            //素材接口
            async getResourceList(pageSize){
                if(pageSize!=undefined) {
                    // console.log(pageSize,"pageSize");
                    this.currentPage=pageSize;
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_mr_id !== "") {
                    this.mid = result.i_mr_id
                    sessionStorage.setItem('mids', result.i_mr_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                    i_pageNum:this.currentPage,
                    i_pageSize:12,
                    vc_introducion:this.explain,
                    dt_startTime:this.begin_time,
                    dt_endTime:this.end_time,
                    i_type:this.iType,
                };
                let res = await API.getResourceList(param);
                if (res.code == 1) {
                    this.allimgData=res.list;
                    this.tableTotal=res.total;
                    //console.log("allimgData",this.allimgData);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //删除
            async batchDelResource(){
                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async () => {
                    let param={
                        idList:this.idList,
                    };
                    let res=await API.batchDelResource(param);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        //console.log(this.currentPage,"当前页");
                        this.getResourceList(this.currentPage);
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },


            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                ///调用列表接口
                this.getResourceList();
            },
        },
    }

</script>

<style lang="scss" scoped>

    .mrr10{
        margin-right: 10px;
    }

    .pagetxt{
        display: inline-block;
        padding: 6px 6px;
        font-size: 14px;
    }

    .ml5{
        margin-left:5px;
    }

    .leftborder{
        border-left: 1px solid #eee;
    }

    .ra{
        height: 100%;
    }

    .flex_search{
        justify-content: space-between;
    }

    .flex_1{
        flex-wrap: nowrap;
        justify-content:  space-between;
    }

    .flex{
        display: flex;
        flex-wrap:wrap;
    }

    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 6px;
    }
    .mrt20{
        margin-top: 20px;
    }
    .mrl20{
        margin-left: 10px;
    }
    .mrb10{
        margin-bottom: 10px;
    }
    /*.page{
        padding: 25px 15px;
    }*/
    .middle{
        line-height: 30px;
    }
    /*.tableHeight{
        min-height: 460px;
        height: 100%;
    }*/
    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }



        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    .cor37{
        color:#c37f00;
    }

    /deep/{
        .danger-row{
            color: #999 !important ;
        }

    }



</style>